import { ConnectMenusa } from 'entities/application/constants/applications/Menusa/ConnectMenusa/ConnectMenusa';
import { MenusaInstruction } from 'entities/application/constants/applications/Menusa/MenusaInstruction';
import { ApplicationWithDetails } from '../../../types';

export const Menusa: ApplicationWithDetails = {
	id: `2659AAE181454A358EC58E6A4969399A`,
	name: `Menusa`,
	description: `QR-меню для ваших ресторанов`,
	descriptionLong: `Замените печатное меню в\xa0ресторане на\xa0онлайн меню по\xa0QR-коду. Теперь не\xa0нужно перепечатывать меню при\xa0его\xa0обновлении. Это\xa0удобно, экономично и\xa0всегда под\xa0рукой. Скачайте уникальный QR-код, распечатайте и\xa0разместите в\xa0ресторане. Ваши гости могут отсканировать код, чтобы\xa0мгновенно изучить меню в\xa0браузере\xa0— без\xa0необходимости скачивания приложения.\n\nQR-меню доступно только для заведений России.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/menusa/logo`,
	sliders: [
		// eslint-disable-next-line sonarjs/no-duplicate-string
		`https://cdn.dodostatic.net/static/marketplace/menusa/slider-ru`,
	],
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/menusa/bgr`,
	conceptions: [`Dodo Pizza`],
	webSiteUrl: `https://menusa.app/`,
	supportUrl: null,
	redirectUrl: ``,
	contactEmail: `info@menusa.app`,
	supportEmail: ``,
	type: `Web`,
	categories: [`Меню`, `QR-меню`, `Ресторан`, `Клиенты`],
	countries: [`Все`],
	languages: [`Русский`],
	price: `Бесплатно`,
	version: `1.0`,
	developer: `Menusa`,
	plans: null,
	instructions: MenusaInstruction,
	details: null,
	knowledgeBase: null,
	showInstruction: false,
	versionHistory: null,
	isExternal: false,
	goToApp: true,
	hasAdditionalFlow: ConnectMenusa,
};
